import { Route, Switch } from 'react-router-dom';
import { LoadComponent } from '@yooink/youtils/es/LoadComponent';
import MenuManager from '@yooink/youtils/es/MenuManager';
import withErrorCatcher from '@yooink/youtils/es/WithErrorCatcher';
import { addPropsToComponent } from '@yooink/youtils/es/AddPropsToComponent';
import PropTypes from 'prop-types';

const List = LoadComponent(() => import('./List'));
const View = LoadComponent(() => import('./View'));



MenuManager.RegisterItem({
	key: 'Users',
	path: '/users',
	name: 'Users'
});

const UsersRoute = (props) => {
	const basePath = props.path || '/users';
	const getPath = (path = '') => `${basePath}${path}`;

	const chain = (component) => withErrorCatcher(addPropsToComponent({
		basePath
	}, component));

	return (
		<>
			<Route
				exact
				path={getPath()}
				component={chain(List)}
			/>
			<Switch>
				
				
				<Route
					exact
					path={getPath('/:id')}
					component={chain(View)}
				/>
			</Switch>
		</>
	);
};

UsersRoute.propTypes = {
	path: PropTypes.string
};

export { UsersRoute };
